var ZOOM_IN_BUTTON_CLASS = 'button fontpack-hero__zoom-in-button';

/**
 * Clicking on an element with `fontpack-hero-zoom-in-button` zoom the hero
 * element in one level.
 *
 * `fontpack-hero-zoom-in-button` must be nested inside of an element with the
 * `fontpack-hero` directive.
 *
 * @ngInject
 */
function FontpackHeroZoomInButton() {
  return {
    // The parent fontpack hero controller is imported automatically because
    // it's declared as a requirement below.
    link: function(scope, element, attrs, fontpackHeroController) {
      element.on('click', function() {
        fontpackHeroController.zoomIn();
      });

      element.addClass(ZOOM_IN_BUTTON_CLASS);
    },

    // Require the parent fontpack-hero's controller to allow this
    // directive to control the state of the overall fontpack-hero.
    require: '^fontpackHero',
    restrict: 'A'
  };
}

module.exports = FontpackHeroZoomInButton;
